(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider-collection"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
	$('.owl-carousel>div').removeClass('disabled');
	$('.owl-carousel>div>button').removeClass('disabled');
});

$('.owl-collection').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
	responsive:{
        0:{
            items:1
        },
        500:{
            items:2
        },
		750:{
			items:3
		},
        1000:{
            items:4
        }
    },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-feature-columns"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
	$('.owl-carousel>div').removeClass('disabled');
	$('.owl-carousel>div>button').removeClass('disabled');
});

$('.owl-blogs').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
	responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    },


});


  } catch(e) { console.error(e); }
})();
})();
